/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
import { RemoteDataActions, FormActions } from 'plugin/liferay-widgets-react-web';
import { ClassNames } from '../constants/Constants';
import JournalWebApi from '../webapi/JournalWebApi';

const className = ClassNames.JournalEntry;

const api = 'JournalWebApi';

export default {
    addEntry: ({ groupId, className, classPK, type, attachments, message }, formId, closeForm) =>
        FormActions.submitForm(JournalWebApi.addEntry, { groupId, className, classPK, type, attachments, message }, formId, closeForm),

    search: (name, query) => RemoteDataActions.list(name, className, query, api + '.' + 'search'),

    moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query)
};



// WEBPACK FOOTER //
// ./js/actions/JournalActions.js